<template>
    <div>
        <nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-dark">
            <a class="navbar-brand" href="#" style="font-size: 20px" @click="navigateToMaster()"><font-awesome-icon icon="arrow-circle-left" /> Back</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="true" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">
                    <li v-show="user" class="nav-item">
                        <router-link class="nav-link" to="/profile"><img :src=user.photoURL width="30" height="30"  alt="" style="border-radius:50%;"> {{user.displayName}}</router-link>
                    </li>
                    <li v-show="user" class="nav-item">
                        <a class="nav-link" @click="signoutButtonPressed">Logout</a>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="right-sidebar">
            <div class="container-fluid">
                <div class="row" style="padding-top: 15px;">
                    <div class="col-md-12">
                        <span>Preview Sequence</span>
                    </div>
                </div>
                <div class="row" style="margin-top: 10px;">
                    <div class="col-md-6 d-flex" style="justify-content: flex-start">
                        <span>Press play to start sequence</span>
<!--                        <button type="submit" class="btn btn-dark btn-sm" :disabled="processing" @click.stop.prevent="startProcessing()">-->
<!--                            <p style="margin-bottom: 0"><font-awesome-icon icon="spinner" /><span style="padding-left: 5px">process</span></p>-->
<!--                        </button>-->
                    </div>
                    <div class="col-md-6 d-flex" style="justify-content: flex-end">
                        <button type="submit" class="btn btn-outline-primary" :disabled="!playNow" @click.stop.prevent="playAll()" style="margin-right: 5px">
                            <font-awesome-icon icon="play"/> play
                        </button>
                        <button type="submit" class="btn btn-outline-danger" :disabled="!continuePlaying" @click.stop.prevent="stopPlaying()">
                            <font-awesome-icon icon="stop"/> stop
                        </button>
                    </div>
                </div>
                <div class="row" style="align-items: center; padding: 10px; margin-bottom: 15px;">
                    <div v-if="processing||loadingData" class="boxStyle d-flex justify-content-center" style="background-color: rgb(243, 246, 249); padding-top: 15%; width: 75vh; height: 30vh;">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <div v-else>
                        <div id ="container" style="background-color: rgb(243, 246, 249);">
                            <div id ="animate"></div>
                        </div>
                    </div>
                </div>
                <div class="row" style="align-items: center; padding: 10px;">
                    <div class="col-sm-12 col-md-12 d-flex" style="justify-content: center">
                        <div class="alert alert-warning" v-if="!validYoutubeUrl(getActiveMasterData.masterData.external_file_url)">
                            <p>masterdata url, should be a valid youtube url, pattern should be</p>
                            <p><strong>https://www.youtube.com/embed/{id}</strong> or <strong>https://www.youtube.com/watch?v={id}</strong></p>
                        </div>
                        <iframe v-else width="560" height="315" :src="prepareYoutubeUrl(getActiveMasterData.masterData.external_file_url)" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>

                <!-- Removing the auto setup of data into the list. This was for debug only. 
                    <div class="row fixed-bottom" style="padding-left: 10px; padding-top: 10px; padding-bottom: 5px; margin-left: 60%; border-top: 1px dashed #1d4354">
                    <div id="col-duration" class="col-md-3">
                        <div class="detail-duration">
                            <input class="form-control"  type="text" maxlength="10"
                                   v-model="tempDuration"
                                   :placeholder=tempDuration>
                            <small class="form-text text-muted">duration</small>
                        </div>
                    </div>
                    <div id="col-re_count" class="col-md-2">
                        <div class="detail-repeat-count">
                            <input class="form-control" type="text" maxlength="10"
                                   v-model="tempRC"
                                   :placeholder=tempRC>
                            <small class="form-text text-muted">repeat count</small>
                        </div>
                    </div>
                    <div id="col-entries" class="col-md-3">
                        <div class="detail-duration">
                            <input class="form-control"  type="text" maxlength="10"
                                   v-model="tempEntries"
                                   :placeholder=tempEntries>
                            <small class="form-text text-muted">No of entries</small>
                        </div>
                    </div>
                    <div id="col-setup" class="col-md-4">
                        <button type="submit" class="btn btn-dark float-right btn-lg" style="font-size: 12px; border-radius: 0" @click.stop.prevent="addTestData()">
                            <font-awesome-icon icon="vial" /> setup data
                        </button>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="content">
            <div class="container-fluid">
                <div class="row" style="padding: 10px">
                    <div v-if="!getActiveMasterData.masterData">
                        <p>Loading ... </p>
                    </div>
                    <div v-else  class="container-fluid" style="padding-right: 0;">
                        <div class="row display-master-data">
                            <div class="col-md-12" style="margin-bottom: 40px">
                                <div class="fixed-top" style="color: rgba(255, 255, 255, 0.75); box-shadow: black 0 8px 6px -6px; margin-top: 61px; margin-right: 40%; background-color: rgb(29, 67, 84)">
                                    <div class="row" style="padding-top: 10px;">
                                        <div id="col-start" class="col-xs-6 col-md-4 align-self-center"></div>
                                        <div id="col-info" class="col-xs-6 col-md-4" style="text-align: center">
                                            <h5 style="color: whitesmoke; margin-bottom: 1px">
                                                {{replaceDescPlaceholderReadView(getActiveMasterData.masterData.description)}}
                                                <li data-toggle="tooltip" data-placement="top" :title=replaceLinkPlaceholderReadView(getActiveMasterData.masterData.external_file_url) @click.stop.prevent="navigateTo(getActiveMasterData.masterData.external_file_url)" class="btn btn-dark btn-sm">
                                                    <font-awesome-icon icon="link" size="sm" /> Link
                                                </li>
                                            </h5>
                                        </div>
                                        <div id="col-end" class="col-xs-6 col-md-4 align-self-center"></div>
                                    </div>
                                    <div class="row pointer" style="padding-left: 10px; padding-bottom: 20px">
                                        <div class="col-md-4">
                                            <p style=" font-size: 18px; margin-bottom: 2px;">Sequence List</p>
                                        </div>
                                        <div class="col-md-8 d-flex" style="justify-content: flex-end">
                                            <button type="submit" class="btn btn-light" @click.stop.prevent="addDetailData()" style="margin-right: 5px">
                                                <font-awesome-icon icon="plus-circle"/> Add
                                            </button>
                                            <button type="submit" class="btn btn-danger" :disabled="activeTab === null" @click.stop.prevent="removeSelected()" style="margin-right: 5px">
                                                <font-awesome-icon icon="trash-alt"/> Remove
                                            </button>
                                            <button type="submit" class="btn btn-primary" @click.stop.prevent="saveDetails()" style="margin-right: 5px">
                                                <font-awesome-icon icon="save"/> Save
                                            </button>
                                            <button type="submit" class="btn btn-secondary" @click.stop.prevent="navigateTo('https://lytesync.toolbunch.com/web-tool-help/')" style="margin-right: 5px">
                                                <font-awesome-icon icon="info-circle"/> Help
                                            </button>
                                        </div>
                                    </div>
<!--                                    <div style="padding-left: 35px; padding-right: 25px">-->
<!--                                        <div class="row detail-wrapper">-->
<!--                                            <div id="col-sq-start-top" class="col-md-2 align-self-center">-->
<!--                                                <div class="detail-duration">-->
<!--                                                    <p class="form-text" style="color: rgb(173, 176, 179); font-size: 14px">Seq#</p>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div id="col-detail-start-top" class="col-md-5 align-self-center">-->
<!--                                                <div class="detail-duration">-->
<!--                                                    <p class="form-text" style="color: rgb(173, 176, 179); font-size: 14px">Descriptive Name</p>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div id="col-detail-mid-top" class="col-md-3 align-self-center">-->
<!--                                                <div class="detail-duration">-->
<!--                                                    <p class="form-text" style="color: rgb(173, 176, 179); font-size: 14px">Duration (ms)</p>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                            <div id="col-detail-end-top" class="col-md-2 align-self-center">-->
<!--                                                <div class="detail-repeat-count">-->
<!--                                                    <p class="form-text" style="color: rgb(173, 176, 179); font-size: 14px">Repeat</p>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
                                </div>
                                <div v-if="loading"  style="margin-top: 115px;">
                                    <p>Loading...</p>
                                </div>
                                <div v-else class="list-group" id="list-tab" role="tablist" style="margin-top: 110px;">
<!-- table goes here-->
                                    <div id="table" class="table-editable table-responsive-md" style="padding: 10px">
                                        <table class="table">
                                            <tr class="row">
                                                <th class="col-sm-1 col-md-1">
                                                    <p style="font-size: 15px">Seq#</p>
                                                </th>
                                                <th class="col-sm-3 col-md-3">
                                                    <p style="font-size: 15px">Descriptive Name</p>
                                                </th>
                                                <th class="col-sm-2 col-md-2">
                                                    <p style="font-size: 15px;">Duration(ms)</p>
                                                </th>
                                                <th class="col-sm-1 col-md-1">
                                                    <p style="font-size: 15px; padding-left: 10px">Repeat</p>
                                                </th>
                                                <th class="col-sm-3 col-md-3">
                                                    <p style="font-size: 15px">Entry Type</p>
                                                </th>
                                                <th class="col-sm-1 col-md-1">
                                                    <p style="font-size: 15px">Extra</p>
                                                </th>
                                                <th class="col-sm-1 col-md-1">
                                                    <p style="font-size: 15px">Value</p>
                                                </th>
                                            </tr>
                                            <tr class="row" :key="index" :ref="getRefId(index)" :id="getRefId(index)"
                                                v-for="(argument, index) of getActiveMasterData.masterData.detail_data"
                                                v-bind:class="[ activeTab === index ? 'active' : 'non-active']"
                                                @click.stop.prevent="setActiveTab(index)">
                                                <td class="col-sm-1 col-md-1" contenteditable="false">
                                                    <input class="form-control" id="seq_no" type="text" maxlength="10" min="0"
                                                           v-model="argument.seq_no"
                                                           style="border: none; padding-left: 5px;"
                                                           @change.stop.prevent="changeSeq()"
                                                           :placeholder=argument.seq_no>
                                                </td>
                                                <td class="col-sm-3 col-md-3" contenteditable="false">
                                                    <input :id="'entry_name_' + index" class="form-control" type="text" maxlength="25"
                                                           v-model="argument.entry_name"
                                                           style="border: none; padding-left: 5px;"
                                                           :placeholder=argument.entry_name>
                                                </td>
                                                <td class="col-sm-1 col-md-2" contenteditable="false">
                                                    <input class="form-control" id="duration" type="text" maxlength="10" min="1"
                                                           style="border: none; padding-left: 5px;"
                                                           v-model="argument.duration"
                                                           :placeholder=argument.duration>
                                                </td>
                                                <td class="col-sm-2 col-md-1" contenteditable="false">
                                                    <input class="form-control" id="repeat_count" type="text" maxlength="10" min="1"
                                                           v-model="argument.repeat_count"
                                                           style="border: none; padding-left: 5px;"
                                                           :placeholder=argument.repeat_count>
                                                </td>
                                                <td class="col-sm-3 col-md-3" contenteditable="false">
                                                    <select v-model="argument.entry_type" class="form-control" style="border: none; padding-left: 5px;">
                                                        <option value="0">off</option>
                                                        <option value="1">on</option>
                                                        <option value="2">fade up</option>
                                                        <option value="3">fade down</option>
                                                        <option value="4">fade up/down</option>
                                                        <option value="5">blink</option>
                                                        <option value="6">level</option>
                                                        <option value="7">end</option>
                                                    </select>
                                                </td>
                                                <td class="col-sm-1 col-md-1" contenteditable="false">
                                                    <input class="form-control" id="extra_data" type="text" maxlength="64" min="0"
                                                           v-model="argument.extra_data"
                                                           style="border: none; padding-left: 5px;"
                                                           :placeholder=argument.extra_data>
                                                </td>
                                                <td class="col-sm-1 col-md-1" contenteditable="false">
                                                    <input class="form-control" id="value" type="text" maxlength="25" min="0"
                                                           v-model="argument.value"
                                                           style="border: none; padding-left: 5px;"
                                                           :placeholder=argument.value>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import {mapGetters} from 'vuex'
    const moment = require('moment');
    import uuid from 'uuid/v4';
    import firebase from "firebase";
    // import virtualList from 'vue-virtual-scroll-list';
    const fb = require('../firebaseConfig.js');
    const { processSequence } = require('../service/api');

    export default {
        name: "MasterDataList",
        data() {
            return {
                user: null,
                activeTab: null,
                addMasterDataRecord: false,
                activeSeqNo: null,
                editSlot: null,
                enableEdit: null,
                enableUpdate: [],
                processing: false,
                loadingData: false,
                playSequence: [],
                boxId: null,
                animationString: '',
                playNow: false,
                continuePlaying: false,
                tempDuration: '1',
                tempRC: 1,
                tempEntries: 0,
                accentColor: '#000',
                animSequence: [
                    {
                        duration: 17530,
                        entry_name: "",
                        entry_type: 0,
                        extra_data: "",
                        repeat_count: 1,
                        value: 0,
                        seq_no: 1
                    },
                    {
                        duration: 35,
                        entry_name: "",
                        entry_type: 0,
                        extra_data: "",
                        repeat_count: 1,
                        value: 256,
                        seq_no: 2
                    }
                ],
                loading: false,
                errors: {}
            }
        },
        components: {
            // 'virtual-list': virtualList,
        },
        mounted() {
            // this.loadTestData();
            this.startProcessing();
        },
        created() {
            firebase.auth().onAuthStateChanged(user => {
                this.user = user;
            });
        },
        computed: {
            ...mapGetters({
                getActiveMasterData: 'getActiveMasterData',
            })
        },
        methods: {
            prepareYoutubeUrl(url) {
                let youtubeEmbedUrl = '';
                console.log('MD BEFORE - ', url);

                if (this.validEmbedYoutubeUrl(url)) {
                    return url;

                } else if (this.validYoutubeUrl(url) && !this.validEmbedYoutubeUrl(url)) {
                    const youtubeId = this.youtubeVideoId(url);
                    youtubeEmbedUrl = 'https://www.youtube.com/embed/' + youtubeId;
                }

                console.log('MD AFTER - ', youtubeEmbedUrl);

                return youtubeEmbedUrl;
            },
            youtubeVideoId(input) {
                return input.match(/(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^&]{10,12})/)[1];
            },
            validYoutubeUrl(url) {
                const regex = /(?:youtu\.be\/|youtube\.com(?:\/embed\/|\/v\/|\/watch\?v=|\/user\/\S+|\/ytscreeningroom\?v=|\/sandalsResorts#\w\/\w\/.*\/))([^&]{10,12})/g;
                return !!url.match(regex);
            },
            validEmbedYoutubeUrl(url) {
                const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/))((\w|-){11})?/g;
                return !!url.match(regex);
            },
            // validYoutubeUrl(url) {
            //     const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/))((\w|-){11})?/g;
            //     return url.match(regex);
            // },
            async boxStyle() {
                if (this.playSequence && this.playSequence.length > 0) {
                    console.log('START', new Date().getTime());
                    this.start(0);
                }
            },
            async start(counter) {
                if ((counter < this.playSequence.length) && this.continuePlaying) {
                    if (this.playSequence[counter].time > 0) {

                        document.querySelector('.boxStyle').style.backgroundColor = this.playSequence[counter].color;
                        await this.wait((this.playSequence[counter].time));
                    }
                    this.start(counter + 1);

                } else {
                    document.querySelector('.boxStyle').style.backgroundColor = 'rgb(243, 246, 249)';
                }
            },
            setActiveTab(tab) {
                this.activeTab = tab;
            },
            wait(ms) {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        resolve()
                    }, ms)
                })
            },
            enableUpdateButton(index) {
                this.enableUpdate[index] = true;
            },
            signoutButtonPressed(e) {
                e.stopPropagation();
                firebase.auth().signOut();
                this.$store.dispatch('cleanCurrentUserStateAction');
                this.$router.push({name: "Login"});
            },
            daysAgo(createdAt) {
                return moment(createdAt).fromNow();
            },
            navigateToMaster() {
                this.$router.push({name: 'Profile'});
            },
            seqNoChange(seqNo) {
                console.log("changing seq no to ", seqNo);
                this.getActiveMasterData.masterData.detail_data.sort(function (a, b) {
                    return a.seq_no - b.seq_no;
                });

                fb.usersCollection.doc(this.getActiveMasterData.userInfo.uid).collection('master').doc(this.getActiveMasterData.masterId)
                    .set(this.getActiveMasterData.masterData, {merge: true}).catch(err => {
                    console.log(err)
                });

                const payload = {
                    id: uuid(),
                    masterId: this.getActiveMasterData.masterId,
                    masterData: this.getActiveMasterData.masterData,
                    userInfo: this.getActiveMasterData.userInfo
                };
                this.$store.dispatch('setActiveMasterDataAction', payload);
            },
            editMasterData(index) {
                this.editSlot = index;
                this.enableEdit = index
            },
            replacePlaceholder(value) {
                return value ? value : 'Start typing something ...'
            },
            replacePlaceholderUrl(value) {
                return value ? value : 'http://...'
            },
            replaceDescPlaceholderReadView(value) {
                return value ? value : 'description section is empty';
            },
            replaceLinkPlaceholderReadView(value) {
                return value ? value : 'no external url added';
            },
            navigateTo(link) {
                window.open(
                    link,
                    '_blank'
                );
            },
            // onDetailSave(index, detail) {
            //
            //     if (detail && detail.seq_no !== '' && detail.duration !== '' && detail.repeat_count !== '' && detail.entry_type !=='' && detail.value !== '') {
            //         console.log(detail);
            //         this.getActiveMasterData.masterData.detail_data[index] = detail;
            //
            //         this.getActiveMasterData.masterData.detail_data.sort(function (a, b) {
            //             return a.seq_no - b.seq_no;
            //         });
            //
            //         fb.usersCollection.doc(this.getActiveMasterData.userInfo.uid).collection('master').doc(this.getActiveMasterData.masterId)
            //             .set(this.getActiveMasterData.masterData, {merge: true}).catch(err => {
            //             console.log(err)
            //         });
            //
            //         this.enableUpdate[index] = false;
            //
            //         const payload = {
            //             id: uuid(),
            //             masterId: this.getActiveMasterData.masterId,
            //             masterData: this.getActiveMasterData.masterData,
            //             userInfo: this.getActiveMasterData.userInfo
            //         };
            //         this.$store.dispatch('setActiveMasterDataAction', payload);
            //         if (this.errors[index]) {
            //             delete this.errors[index];
            //         }
            //
            //     } else {
            //         console.log('fields should not have empty values');
            //         this.errors[index] = true
            //     }
            // },
            changeSeq(){

                this.getActiveMasterData.masterData.detail_data.sort(function (a, b) {
                    return a.seq_no - b.seq_no;
                });

                const payload = {
                    id: uuid(),
                    masterId: this.getActiveMasterData.masterId,
                    masterData: this.getActiveMasterData.masterData,
                    userInfo: this.getActiveMasterData.userInfo
                };
                this.$store.dispatch('setActiveMasterDataAction', payload);
            },
            saveDetails() {
                this.getActiveMasterData.masterData.detail_data.sort(function (a, b) {
                    return a.seq_no - b.seq_no;
                });

                fb.usersCollection.doc(this.getActiveMasterData.userInfo.uid).collection('master').doc(this.getActiveMasterData.masterId)
                    .set(this.getActiveMasterData.masterData, {merge: true}).catch(err => {
                    console.log(err)
                });

                const payload = {
                    id: uuid(),
                    masterId: this.getActiveMasterData.masterId,
                    masterData: this.getActiveMasterData.masterData,
                    userInfo: this.getActiveMasterData.userInfo
                };
                this.$store.dispatch('setActiveMasterDataAction', payload);

                this.startProcessing();
            },
            async addDetailData() {
                this.loading = true;
                this.getActiveMasterData.masterData.detail_data.sort(function (a, b) {
                    return a.seq_no - b.seq_no;
                });
                const len = this.getActiveMasterData.masterData.detail_data.length;
                const lastIndex = len > 0 ? (len - 1) : 0;
                const highestExtSeqNo = len > 0 ? parseInt(this.getActiveMasterData.masterData.detail_data[lastIndex].seq_no) : 0;
                const newHighestSeqNo = highestExtSeqNo + 1;

                this.getActiveMasterData.masterData.detail_data.push({
                    duration: "0",
                    entry_name: "",
                    entry_type: "0",
                    extra_data: "0",
                    repeat_count: "1",
                    value: "0",
                    seq_no: newHighestSeqNo
                });

                fb.usersCollection.doc(this.getActiveMasterData.userInfo.uid).collection('master').doc(this.getActiveMasterData.masterId)
                    .set(this.getActiveMasterData.masterData, {merge: true}).catch(err => {
                    console.log(err)
                });

                const payload = {
                    id: uuid(),
                    masterId: this.getActiveMasterData.masterId,
                    masterData: this.getActiveMasterData.masterData,
                    userInfo: this.getActiveMasterData.userInfo
                };
                this.$store.dispatch('setActiveMasterDataAction', payload);

                await this.wait(100);
                this.loading = false;
            },
            getRandomInt(max) {
                return Math.floor(Math.random() * Math.floor(max));
            },
            loadTestData() {
                this.loadingData = true;
                const tempData = [];
                const testEntries = 1000;
                for (let i = 0; i < testEntries; i++) {
                    const payload = {
                        duration: 20,
                        entry_name: "",
                        entry_type: this.getRandomInt(3),
                        extra_data: "",
                        repeat_count: 1,
                        value: 0,
                        seq_no: i
                    };
                    tempData.push(payload);
                }

                this.getActiveMasterData.masterData.detail_data = tempData;

                fb.usersCollection.doc(this.getActiveMasterData.userInfo.uid).collection('master').doc(this.getActiveMasterData.masterId)
                    .set(this.getActiveMasterData.masterData, {merge: true}).catch(err => {
                    console.log(err)
                });

                const payload = {
                    id: uuid(),
                    masterId: this.getActiveMasterData.masterId,
                    masterData: this.getActiveMasterData.masterData,
                    userInfo: this.getActiveMasterData.userInfo
                };
                this.$store.dispatch('setActiveMasterDataAction', payload);
                this.loadingData = false;

                this.startProcessing();
            },
            async addTestData() {
                 this.getActiveMasterData.masterData.detail_data = [];

                this.loadingData = true;
                // const tempData = [];
                // const testEntries = parseInt(this.tempEntries);
                // if (testEntries > 0) {
                //     for(let i=0; i < testEntries; i++) {
                //         const payload = {
                //             duration: parseInt(this.tempDuration),
                //             entry_name: "",
                //             entry_type: 0,
                //             extra_data: "",
                //             repeat_count: parseInt(this.tempRC),
                //             value: 0,
                //             seq_no: i
                //         };
                //         tempData.push(payload);
                //     }

                // this.getActiveMasterData.masterData.detail_data = tempData;
                this.getActiveMasterData.masterData.detail_data = this.animSequence;

                fb.usersCollection.doc(this.getActiveMasterData.userInfo.uid).collection('master').doc(this.getActiveMasterData.masterId)
                    .set(this.getActiveMasterData.masterData, {merge: true}).catch(err => {
                    console.log(err)
                });

                const payload = {
                    id: uuid(),
                    masterId: this.getActiveMasterData.masterId,
                    masterData: this.getActiveMasterData.masterData,
                    userInfo: this.getActiveMasterData.userInfo
                };
                this.$store.dispatch('setActiveMasterDataAction', payload);
                await this.wait(1500);
                this.loadingData = false;
                // }

            },
            async startProcessing() {
                this.processing = true;
                this.playNow = false;

                if (this.errors && Object.keys(this.errors).length === 0) {
                    if (this.getActiveMasterData.masterData.detail_data && this.getActiveMasterData.masterData.detail_data.length > 0) {

                        let res;
                        try {
                            res = await processSequence(this.getActiveMasterData.masterData.detail_data);
                            this.playSequence = res.list;
                            await this.wait(20);
                            this.processing = false;
                            this.playNow = true;

                        } catch(e) {
                            window.alert('Error: Something is messed up in the sequence.');
                            this.playSequence = [];
                            this.processing = false;
                            this.playNow = false;
                        }

                    } else {
                        this.playSequence = [];
                        this.processing = false;
                        this.playNow = false;
                    }
                } else {
                    console.log('get rid of all the errors');
                    this.processing = false;
                    this.playNow = false;
                }
            },
            playAll() {
                if (!this.processing && this.playSequence.length > 0) {
                    this.playNow = true;
                    this.continuePlaying = true;
                    this.myMove()
                }
            },
            removeSelected() {
                if (this.getActiveMasterData.masterData.detail_data && this.getActiveMasterData.masterData.detail_data.length > 0) {
                    this.getActiveMasterData.masterData.detail_data.splice(this.activeTab, 1);

                    fb.usersCollection.doc(this.getActiveMasterData.userInfo.uid).collection('master').doc(this.getActiveMasterData.masterId)
                        .set(this.getActiveMasterData.masterData, {merge: true}).catch(err => {
                        console.log(err)
                    });

                    const payload = {
                        id: uuid(),
                        masterId: this.getActiveMasterData.masterId,
                        masterData: this.getActiveMasterData.masterData,
                        userInfo: this.getActiveMasterData.userInfo
                    };
                    this.$store.dispatch('setActiveMasterDataAction', payload);
                }
            },
            stopPlaying() {
                this.continuePlaying = false;
            },
            getRefId(index) {
                return 'seq_' + index;
            },
            myMove() {
                const sequenceList = this.playSequence;
                let playBackIndex = 0;
                const numEntries = sequenceList.length;
                let startTime = new Date();
                let endMillis = 0;
                let color;
                let currentColor;

                if (numEntries > 0) {
                    endMillis = sequenceList[playBackIndex].timeout;
                    color = sequenceList[playBackIndex].color;
                }

                let id = setInterval(() => {
                    if (this.continuePlaying) {
                        frame();
                    } else {
                        playBackIndex = 0;
                        clearInterval(id);
                        document.getElementById("container").style.background = 'rgb(243, 246, 249)';
                    }
                }, 1);

                function frame() {
                    let elem = document.getElementById("container");
                    let currentTime = new Date();
                    if ((playBackIndex < numEntries)) {
                        while (((currentTime - startTime) > endMillis) &&
                        (playBackIndex < numEntries)) {
                            endMillis = sequenceList[playBackIndex].timeout;
                            color = sequenceList[playBackIndex].color;
                            playBackIndex++;
                        }
                        if (color !== currentColor) {
                            elem.style.background = color;
                            currentColor = color;
                        }
                    } else {
                        clearInterval(id);
                    }
                }
            }
        },
    }
</script>


<style scoped>
    #virtual-list-style::-webkit-scrollbar {
        background-color: rgb(243, 246, 249);
        border-radius: 10px;
        width: 15px;
    }
    #virtual-list-style::-webkit-scrollbar-thumb {
        background-color: #4f566b;
        border-radius: 10px;
    }
    #container {
        width: 80vh;
        height: 25vh;
        background: rgb(243, 246, 249);
    }
    .youtube-frame {
        width: 80vh;
        height: 40vh;
    }
    .scroller {
        height: 100%;
    }
    .boxStyle {
        /*margin-top: 10px; padding: 10px; width: 80vh; height: 68vh; background-color: #343a40;*/
        /*margin-top: 10px; padding: 10px; width: 200px; height: 200px;*/
        margin-top: 10px; padding: 10px; width: 80vh; height: 68vh;
    }
    .left-sidebar {
        position: fixed; top:60px; left: 0; width: 10%; height: 100%; background-color: rgb(29, 67, 84); border-right: 1px solid rgba(0,0,0,.07)
    }
    .right-sidebar {
        position: fixed; top:60px; right: 0; width: 40%; height: 100%; background-color: #fff; border-left: 1px solid rgba(0,0,0,.06)
    }
    .content {
        position: relative; top:60px; margin-right: 40%; height: 100%;
    }
    .active{
        background-color: #8c9298;
    }
    .non-active {
        background-color: white;
    }
    .static-top {
        position: fixed; top:60px; height: 70px;
    }
    .box-again {
        animation: toBlack 10ms ease-in;
    }
    .pointer {
        cursor: pointer;
    }
    @keyframes fadeIn {
        from { opacity: 0; }
        to   { opacity: 1; }
    }
    @keyframes toWhite {
        from {background-color: #000000;}
        to {background-color: #ffffff;}
    }
    @keyframes toBlack {
        from {background-color: #ffffff;}
        to {background-color: #000000;}
    }
</style>
